import styled from 'styled-components';
import { StyledPopUpBlock } from '../styled';

export const StyledPopupHeader = styled.div`
  background-color: ${({ theme }) => theme.surfaceAlt};
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 0 30px;
  z-index: 1;
  width: 100%;
  height: 85px;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.text};
  img {
    max-width: 50px;
    width: auto;
    height: auto;
    max-height: 50px;
  }
`;

export const StyledPopUpBlockNoPadding = styled(StyledPopUpBlock)`
  width: 340px;
  padding: 0;
  border-radius: ${({ theme }) => theme.cardRadius};
  overflow: hidden;
`;
export const StyledParagraph = styled.p`
  font-family: var(--tol-font-ui);
  font-size: 15px;
  line-height: 26px;
  padding: 30px;
  color: ${({ theme }) => theme.text};
`;
